<template>
    <Layout>

        <b-modal
                id="modalUpload"
                scrollable
                title="Subir archivo"
                title-class="font-18"
                size="lg"
                no-close-on-esc
                hide-footer
                centered
        >
            <subirArchivos v-on:upload-complete="uploadComplete" />
        </b-modal>

        <div class="card">
            <b-overlay :show="isLoading" rounded="sm">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label>Filtro de escuela</label>
                            <v-select
                                    :options="carreras_profesionales"
                                    label="carrera"
                                    :reduce="carrera=>carrera.codigo"
                                    v-model="codigo_carrera"
                                    @input="cargarIndicadores()"
                            />
                        </div>
                        <div class="form-group col-md-6">
                            <label>Indicadores</label>
                            <v-select
                                    :options="filtrarIndicadores"
                                    label="nombre"

                                    v-model="indicador_selecionado"
                                    @input="cargarOpciones()"
                            />
                        </div>
                        <div class="form-group col-md-2" >
                            <label>Opciones</label>
                            <v-select
                                    :options="indicador_selecionado.opciones"
                                    label="nombre"
                                    v-model="opcion_seleccionada"
                            />
                        </div>
                        <div class="form-group col-md-1" >
                            <button class="btn btn-primary mt-4" v-on:click="guardar" >Guardar</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10">
                            <ag-grid-vue
                                    style="width: 100%; height: 400px"
                                    class="ag-theme-alpine"
                                    :columnDefs="columnDefs"
                                    :rowData="rowData"
                                    :gridOptions="gridOptions"
                                    @grid-ready="onGridReady"

                            >
                            </ag-grid-vue>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-outline-info m-2" v-on:click="abrirCarga">Cargar estudiantes</button>
                            <button class="btn btn-outline-info m-2" v-on:click="validarEstudiantes">Validar Estudiantes</button>
                        </div>


                    </div>
                </div>
            </b-overlay>

        </div>


    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    //import PageHeader from "@/components/page-header";
    import subirArchivos from "@/components/subir-archivos";
    import "ag-grid-community/dist/styles/ag-grid.css";
    import "ag-grid-community/dist/styles/ag-theme-alpine.css";

    import {AgGridVue} from "ag-grid-vue";
    import constantes from "../../../config/Constantes";
    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Recepción de expedientes",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            Layout,
            //PageHeader,
            subirArchivos,
            'ag-grid-vue':AgGridVue
        },
        data() {
            return {

                title: "Estudiantes ",
                items: [
                    {
                        text: "Estudiantes",
                        href: "/"
                    },
                    {
                        text: "Lista",
                        active: true
                    }
                ],
                isLoading: false,
                gridApi: null,
                columnApi: null,
                gridOptions: {

                    //floatingFiltersHeight:50,
                    defaultColDef: {
                        sortable: true,resizable: true
                    },
                },
                columnDefs:[],
                rowData:[],
                carreras_profesionales:[],
                codigo_carrera:null,
                indicador_selecionado:{ opciones:[]},
                indicadores:[],
                opciones:[],
                opcion_seleccionada:null

                ////////////////
            };
        },

        methods: {
            guardar(){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/estudiantes/guardar-indicador-bloque",
                    {
                        lista:this.rowData,
                        codigo_carrera:this.codigo_carrera,
                        indicador_selecionado:this.indicador_selecionado,
                        opcion_seleccionada:this.opcion_seleccionada
                    }
                )
                    .then((response)=>{
                        this.rowData=response.data;
                        //this.indicadores=response.data;
                    })
                    .finally(()=>this.isLoading=false)
            },
            validarEstudiantes(){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/estudiantes/cargar-nombres",
                    {
                        lista:this.rowData,
                        codigo_carrera:this.codigo_carrera
                    }
                )
                    .then((response)=>{
                        this.rowData=response.data;
                        //this.indicadores=response.data;
                    })
                    .finally(()=>this.isLoading=false)
            },
            abrirCarga(){
                this.$bvModal.show("modalUpload");
            },
            cargarOpciones(){

            },
            cargarIndicadores(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/estudiantes/leer-indicadores/"+this.codigo_carrera)
                    .then((response)=>{
                        this.indicadores=response.data;
                    })
                    .finally(()=>this.isLoading=false)
            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;

            },
            uploadComplete(files){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/estudiantes/procesar-lista",
                    {
                        file:files,
                    })
                    .then((response)=>{
                        console.log(response);
                        this.rowData=response.data;
                        this.$bvModal.hide("modalUpload");
                    })
                    .finally(()=>this.isLoading=false)
            },
            rellenar(){
                var i,data;
                data=[];
                for(i=0;i<100;i++){
                    data.push({
                        codigo:"",
                        nombre:"",
                        validado:""
                    });
                }
                this.rowData=data;
            }
        },
        beforeMount() {
            this.columnDefs= [
                {
                    headerName: "Codigo",
                    field: "codigo",
                    resizable: true
                    ,width:"150px",
                    filter: true,
                    floatingFilter: true,
                    editable:true
                },
                {
                    headerName: "Nombres",
                    field: "nombres",
                    resizable: true ,
                    width:"400px",
                    filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Validado",
                    field: "validado",
                    resizable: true ,
                    width:"150px",
                    filter: true,
                    floatingFilter: true,
                },
            ];
            this.rowData= [

            ];

        },
        computed: {
            filtrarIndicadores(){
                return this.indicadores.filter(item => item.permiso_edicion ==true)
            }

        },
        mounted() {
            this.carreras_profesionales =JSON.parse(JSON.stringify(constantes.carreras_profesionales_habilitadas));// {... };
            this.rellenar();
        },

    };
</script>
